import { useEffect, useState } from 'react';
import './Kundali.scss';

import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';

import Zodiac from '../../../components/ZodiacSign/Zodiac';
import axios from 'axios';
import JyotishLinks from '../../../components/JyotishLinks/JyotishLink';
import KundaliLagna from './KundaliChart/KundaliLagna';
import KundaliNavam from './KundaliChart/KundaliNavam';
import city from '../../../city.json'



const Kundali = () => {

  const [lagnaData, setLagnaData] = useState(null);
    const [location, setLocation] = useState("Kolkata");
  const [currentDate, setCurrentDate] = useState(new Date());


const [time, setTime] = useState(() => {
  const now = new Date();
  return now.toTimeString().split(' ')[0].slice(0, 5); // HH:MM
});


    const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];


   // Temporary states for user input for submit button
const [tempDate, setTempDate] = useState(currentDate);
const [tempLocation, setTempLocation] = useState("Kolkata");
const [suggestions, setSuggestions] = useState([]);


  useEffect(() => {
    const fetchLagnaKundali = async () => {
      if (!location || location.trim() === '') return;
      const formattedDate = currentDate.toISOString().split('T')[0];


      try {
        //const dateObj = new Date();
        //const currentTime = dateObj.toTimeString().split(' ')[0].slice(0, 5); // HH:MM

        const res = await axios.get(
          `https://core-c343.onrender.com/api/kundli?date=${formattedDate}T${time}:00&location=${encodeURIComponent(location)}`
        );

        setLagnaData(res.data);
      } catch (error) {
        console.error('Failed to fetch Lagna Kundali', error);
      }
    };

    fetchLagnaKundali();
  }, [location, currentDate, time]);




  

  const handlePrevDay = () => {
    const prev = new Date(currentDate);
    prev.setDate(prev.getDate() - 1);
    setCurrentDate(prev);
  };

  const handleNextDay = () => {
    const next = new Date(currentDate);
    next.setDate(next.getDate() + 1);
    setCurrentDate(next);
  };

  const handleDateInput = (e) => {
    setTempDate(new Date(e.target.value));
  };

const handleMonthClick = (monthIndex) => {
  const newDate = new Date(tempDate);
  newDate.setMonth(monthIndex);
  setTempDate(newDate);
};

const handleDayClick = (day) => {
  const newDate = new Date(tempDate);
  newDate.setDate(day);
  setTempDate(newDate);
};

const handleSubmit = () => {
  setCurrentDate(tempDate);
  setLocation(tempLocation);
};

  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };

  const formattedDate = currentDate.toISOString().split("T")[0];



  const renderTable = (data) => (
    <table>
      <thead>
        <tr>
          <th>Graha</th>
          <th>Longitude</th>
          <th>Nakshatra</th>
          <th>Nakshatra Lord/Sub</th>
          <th>Sub Lord</th>
          <th>Ruler Of</th>
          <th>Is In</th>
          <th>Relationship</th>
          <th>Bhava Owner</th>
          <th>Dignity</th>
          {/* <th>Retrograde</th> */}
        </tr>
      </thead>
      <tbody>
        {data.map((planetObj, idx) => (
          <tr key={idx}>
            <td>{planetObj.planet}</td>
            <td>{planetObj.longitude}</td>
            <td>{planetObj.nakshatra}</td>
            <td>{planetObj.nakshatraLord}</td>
            <td>{planetObj.subLord}</td>
            <td>{planetObj.rulerOf}</td>
            <td>{planetObj.isIn}</td>
            <td>{planetObj.relationship}</td>
            <td>{planetObj.bhavaOwner}</td>
            <td>{planetObj.dignity}</td>
            {/* <td>{planetObj.retrograde === true ? 'True' : 'False'}</td> */}
          </tr>
        ))}
      </tbody>
    </table>
  );


  return (
    <div className="kundali-containerr">
      <InnerNav />
      <div className="kundali-content">
        <Zodiac />
              <div className="controls">
                <div className="month-grid">
                  {months.map((month, i) => (
                    <button key={i} onClick={() => handleMonthClick(i)}>{month}</button>
                  ))}
                </div>

                <div className="day-grid">
                  {Array.from({ length: 31 }, (_, i) => (
                    <button key={i} onClick={() => handleDayClick(i + 1)}>{i + 1}</button>
                  ))}
                </div>

                <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  <input
                    type="date"
                    value={tempDate.toISOString().split("T")[0]}
                    onChange={handleDateInput}
                  />
                  <div className="time">
                  <input
                    type="time"
                    value={time}
                    onChange={(e) => setTime(e.target.value)}
                  />
                </div>
                  <button onClick={handlePrevDay}>Prev Day</button>
                  <button onClick={handleNextDay}>Next Day</button>
                  <button onClick={handleSubmit}>Submit</button>

                </div>
                

              </div>
              <div className="kundali-chartss">
                <div className="chartt-box">
                  <KundaliLagna date={currentDate}  />
                </div>
                <div className="chartt-box">
                <KundaliNavam date={currentDate}  />
                </div>
              </div>
        <div className="chart-details-container">
          <div className="chart-box">
            <h2>Rashi Chart Details</h2>
            {lagnaData?.rashiChart ? renderTable(lagnaData.rashiChart) : <p>Loading Rashi Chart...</p>}
          </div>
          <div className="chart-box">
            <h2>Navamsha Chart Details</h2>
             {lagnaData?.navamshaChart ? renderTable(lagnaData.navamshaChart) : <p>Loading Navamsha Chart...</p>}
          </div>
        </div>
        <JyotishLinks/>
        {/* <CommentBox /> */}
      </div>
      <Footer />
    </div>
  );
};

export default Kundali;
